<template>

	<div class="modal">

		<div class="modal-wrap">

			<div :class="{'modal-inner':true}">

				<h2 :class="{'modal-title':true}"><span class="text-wrap" :title="title">{{ title }}</span><span v-if="!hideClose" class="close" @click="close">X</span></h2>

				<div class="modal-inner-scroll">

					<form class="form" @submit.prevent="submit">

						<h3 class="sub-title">{{ subTitle }}</h3>

						<ul class="idea-list" v-if="theList.length">
							<li
								v-for="(listItem, listItemIndex) in theList" 
								:key="'list-item-'+listItemIndex" 
							>{{listItem}}</li>
						</ul>

						<p class="error" v-if="error" v-html="error" />

						<div class="needs-credits" v-if="needsAction">

							<p>You have hit your limit of {{freeLimit}} free {{title}}. Don't worry though, you can get another {{freeLimit}} for 1 analysis credit. <span v-if="hasCredits">Click the button below to use one of your credits</span><span v-if="!hasCredits"><br />You will need to purchase more analysis credits though, click the button below to buy 1000 for $10</span>.</p>
							<span class="large-button mini" v-if="hasCredits" @click="chargeCredit">Charge me 1 Analysis Credit</span>
							<span class="large-button mini" v-if="!hasCredits" @click="showPayment=true">Purchase 1000 analysis credits ($10)</span>
							<p @click="showTheHow" class="more-info">Click here for information on analysis credits.</p>

						</div>

					</form>

				</div>

				<Loading v-if="loadingText!==''" position="inner" :text="loadingText" />

			</div>

		</div>

		<AnalysisCreditsHow
			v-if="showHow"
			@close="closeHow"
		/>

		<AnalysisCreditsOops
			v-if="showPayment"
			:straightToPayment="true"
			@close="closePayment" 
		/>

	</div>

</template>

<script>
import { mapMutations, mapState } from 'vuex'
import ApiService from './../../services/api.service'
import general from './../../utils/general'
import AnalysisCreditsHow from './AnalysisCreditsHow.vue'
import AnalysisCreditsOops from './AnalysisCreditsOops.vue'
import Loading from './../Loading.vue'
export default {
	name: 'ContentHeadingIdeas',
	components: {
		AnalysisCreditsHow,
		AnalysisCreditsOops,
		Loading
	},
	props: {
		info: {
			type: Object,
			default: function () {
				return {}
			}
		},
		type: {
			type: String,
			default: 'contentTitleIdeas'
		}
	},
	data() {

		return {
			showHow: false,
			showPayment: false,
			loadingText: '',
			hideClose: false,
			newList: [],
			max: false,
			error: ''
		}

	},
	computed: { 

		...mapState('general',['analysisCredits']),

		theList () {

			return this.info.list && this.info.list.length ? this.info.list : ( this.newList.length ? this.newList : [] );

		},

		needsAction () {

			return this.analysisCredits.all < 1 || this.max;

		},

		freeLimit () {

			return 10;

		},

		title () {

			if ( this.type === 'topicalClusterIdeas' ) return 'Topical Cluster Ideas';

			return "Content Heading Ideas";

		},
		subTitle () {

			return '"' + this.info.keyword + '"';

		},
		hasCredits () {

			return this.analysisCredits > 0;

		},
		tooManyRetries () {

			return this.info.retries >= 3;

		},

		uri () {

			if ( this.type === 'topicalClusterIdeas' ) return 'topical-cluster-ideas';

			return 'content-heading-ideas';

		}

    },
	methods: {

		...mapMutations('general',['updateVar']),

		chargeCredit () {

			this.loadingText = 'One moment...';
			this.max = false;

			ApiService.get( 'googlea/analysis-credits/charge/'+this.uri+'/1' )
			.then( function( info ) {

				this.updateVar( {varName:'reloadAnalysisCredits', info:false} ); 

				setTimeout( function () { 

					this.updateVar( { varName: 'analysisCredits', info:info.data.all } ); 
					this.updateVar( { varName: 'analysisCreditsInfo', info:info.data } ); 

						this.loadUp ('Fetching ideas...');

					}.bind(this), 10 );

			}.bind(this))
			.catch( function(error) {

				this.loadingText = '';
				this.error = general.getErrorMessage(error);

			}.bind(this));

		},

		closeHow () {

			this.showHow = false;

			general.modalClose();

		},

    	showTheHow () {

			this.showHow = true;

		},

		showThePayment () {

			this.showPayment = true;

		},

		closePayment () {

			this.showPayment = false;

			general.modalClose();

			this.chargeCredit ();

		},

		close() {

			this.$emit('close');

		},
		loadUp (msg) {

			this.loadingText = msg || 'Loading...';

			ApiService.get( 'googlea/'+this.uri+'/' + this.info.type + '/' + this.info._id )
			.then( function( response ) {

				this.loadingText = '';

				if ( response.data === 'max' ) {

					this.max = true;

				}
				else {

					this.newList = response.data;
					this.$emit('refresh');

				}

			}.bind(this))
			.catch( function(error) {

				this.loadingText = '';
				this.error = general.getErrorMessage(error);

			}.bind(this));

		}
	},
	mounted() {

		if ( !this.theList.length && !this.needsAction && !this.tooManyRetries ) {
		
			this.loadUp ('Fetching ideas...');

		}

		if ( this.tooManyRetries ) {

			this.error = "We are having an issue with this keyword and it has been retried too many times without any success, we are looking into the issue, sorry for the inconvenience.";

		}

	}
}
</script>

<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';
.modal {

	.modal-wrap {

		padding: 20px;

	}

	.modal-inner {

		max-width:550px;

		&:before {

			display: none;

		}

		.modal-title {

		}

		.sub-title {

			margin: 0 0 10px 0;
			
		}

		.idea-list {

			margin:0;
			padding: 0 0 0 15px;

			li {

				margin:0;
				padding: 0 0 5px 0;

			}

		}

		p {

			&.error {

				font-weight: 500;
				color: @red;

			}

			&.powered-by {

				margin: 15px 0 0;
				font-size: 12px;
				color: @formDefaultColour;
				font-weight: 500;
				min-height: 20px;
				padding: 0 0 0 28px;
				position: relative;
				line-height: 1.75em;

				svg {

					width: 20px;
					position: absolute;
					left: 0;
					top: 0;

				}

			}

		}

		.needs-credits {

			p {

				padding: 0;
				margin: 0 0 15px 0;

				&.more-info {

					color: @formDefaultColour;
					font-size: 14px;
					cursor: pointer;
					margin-top: 15px;
					margin: 15px 0 10px;

					&:hover {

						text-decoration: underline;

					}

				}

			}

			.large-button {

				margin: 0;

			}

		}

	}

	.modal-inner-scroll {

		min-height: 66px;
   	 	padding-bottom: 0;

	}

}
</style>